//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibFinalBox',
  props: {
    logo: {
      type: String
    },
    src: {
      type: String
    },
    widthLogo: {
      type: String,
      default: '114px'
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    titleStyles: function titleStyles() {
      if (this.src) {
        return {
          backgroundImage: "url(".concat(this.src, ")")
        };
      }

      return {
        background: "linear-gradient(130deg, ".concat(this.theme.gradientColorStart, ", ").concat(this.theme.gradientColorStart, " 20%, ").concat(this.theme.gradientColorEnd, ")")
      };
    }
  }
};